/* tslint:disable */
/* eslint-disable */
/**
 * Track API
 * The Track API provides access to SPiDRs and Security Focuses.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TaskPriorityFromJSON, TaskPriorityToJSON, } from './TaskPriority';
import { TaskStateFromJSON, TaskStateToJSON, } from './TaskState';
import { TaskTypeFromJSON, TaskTypeToJSON, } from './TaskType';
/**
 * Check if a given object implements the TaskWithDetailsResponse interface.
 */
export function instanceOfTaskWithDetailsResponse(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "metadata" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "priority" in value;
    isInstance = isInstance && "version" in value;
    isInstance = isInstance && "orgID" in value;
    isInstance = isInstance && "rejectedReason" in value;
    isInstance = isInstance && "updatedBy" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;
    isInstance = isInstance && "commentsCount" in value;
    isInstance = isInstance && "attachmentsCount" in value;
    return isInstance;
}
export function TaskWithDetailsResponseFromJSON(json) {
    return TaskWithDetailsResponseFromJSONTyped(json, false);
}
export function TaskWithDetailsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'title': json['title'],
        'metadata': json['metadata'],
        'type': TaskTypeFromJSON(json['type']),
        'state': TaskStateFromJSON(json['state']),
        'description': json['description'],
        'priority': TaskPriorityFromJSON(json['priority']),
        'version': json['version'],
        'orgID': json['orgID'],
        'rejectedReason': json['rejectedReason'],
        'updatedBy': json['updatedBy'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'commentsCount': json['commentsCount'],
        'attachmentsCount': json['attachmentsCount'],
    };
}
export function TaskWithDetailsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'title': value.title,
        'metadata': value.metadata,
        'type': TaskTypeToJSON(value.type),
        'state': TaskStateToJSON(value.state),
        'description': value.description,
        'priority': TaskPriorityToJSON(value.priority),
        'version': value.version,
        'orgID': value.orgID,
        'rejectedReason': value.rejectedReason,
        'updatedBy': value.updatedBy,
        'createdAt': (value.createdAt.toISOString()),
        'updatedAt': (value.updatedAt.toISOString()),
        'commentsCount': value.commentsCount,
        'attachmentsCount': value.attachmentsCount,
    };
}
